import React, { useEffect } from "react";
import { Helmet } from "react-helmet";
import HeroSection from "./HeroSection";
import ContactUs from "./ContactUs";

const FullContactUsPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Helmet>
        <title>Contact Us | Ashlar Building Group</title>
        <meta
          name="description"
          content="Get in touch with Ashlar Building Group to discuss your custom home, ADU, remodel, or HOA reconstruction project. Schedule your free consultation today."
        />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href="https://yourdomain.com/contact" />
        <meta property="og:title" content="Contact Us | Ashlar Building Group" />
        <meta
          property="og:description"
          content="Ready to start your project? Contact Ashlar Building Group — California's trusted high-value construction firm. We respond quickly and take your project seriously."
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://yourdomain.com/contact" />
      </Helmet>

      <HeroSection />
      <ContactUs />
    </>
  );
};

export default FullContactUsPage;